export enum RoutePath {
  Home = '/',
  BreathingDots = '/dots',
  CcmExercises = '/ccm-exercises' // Code as Creative Medium
}